export const PHASER_VIEW_WIDTH = 960;
export const PHASER_VIEW_HEIGHT = 540;

export const SCENE_KEYS = {
  boot: "BootScene",
  battle: "BattleScene",
} as const;

export const GAME_EVENTS = {
  battleReady: "yoake:battle-ready",
  status: "yoake:status",
  happiness: "yoake:happiness",
  happinessDelta: "yoake:happiness-delta",
  uiState: "yoake:ui-state",
  resolutionStart: "yoake:resolution-start",
  resolutionEvent: "yoake:resolution-event",
  resolutionEnd: "yoake:resolution-end",
  logReset: "yoake:log-reset",
  audioCue: "yoake:audio-cue",
} as const;
